import React from 'react'
import ReduxToastr from 'react-redux-toastr';

import 'react-redux-toastr/src/styles/index.scss';

const Toastr = () => (
  <ReduxToastr
    timeOut={2000}
    newestOnTop={false}
    preventDuplicates
    position="top-right"
    transitionIn="fadeIn"
    transitionOut="fadeOut"
  />
)

export default Toastr



// WEBPACK FOOTER //
// ./containers/Root/ReduxToastr.js